import clamp from "lodash/clamp";
import { ChangeEvent } from "react";
import { ChevronBarLeft, ChevronBarRight, ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import { ActionHandler } from "../../types";
import "./pagination.scss";

type PaginationProps = {
	itemsPerPage: number;
	currentPage: number;
	numberOfRegistries: number;
	onPageChange: ActionHandler<number>;
	onItemsPerPageChange: ActionHandler<number>;
};

export const calculatePages = (registries: number, registriesPerPage: number) =>
	Math.ceil(registries / registriesPerPage);

const Pagination = (props: PaginationProps) => {
	const firstPage = clamp((props.itemsPerPage * props.currentPage) - (props.itemsPerPage - 1), 0, props.numberOfRegistries);
	const lastPage = clamp(props.itemsPerPage * props.currentPage, 0, props.numberOfRegistries);
	const totalPages = calculatePages(props.numberOfRegistries, props.itemsPerPage);

	const changePage = (page: number) => {
		if (props.currentPage !== page) {
			props.onPageChange(clamp(page, 1, totalPages));
		}
	};

	const first = () => changePage(1);

	const last = () => changePage(totalPages);

	const previous = () => changePage(props.currentPage - 1);

	const next = () => changePage(props.currentPage + 1);

	const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
		props.onItemsPerPageChange(Number(e.target.value));
	};

	return (
		<div className="paginator">
			<span>Filas por página</span>
			<select className="paginator-select" defaultValue="10" onChange={onChange}>
				<option value="5">5</option>
				<option value="10">10</option>
				<option value="15">15</option>
			</select>
			<span className="ms-2 me-2">{firstPage}-{lastPage} de {props.numberOfRegistries}</span>
			<ChevronBarLeft role="button" onClick={first} />
			<ChevronLeft role="button" onClick={previous} />
			<ChevronRight role="button" onClick={next} />
			<ChevronBarRight role="button" onClick={last} />
		</div>
	);
};

export default Pagination;